import { api } from "../lib";
import { DocumentViewResponse } from "../types/reportTemplate";

export const documentViewService = {
  fetchDocumentViewData: async (
    caseId: string,
    templateId?: string,
    reportVersion?: number
  ): Promise<DocumentViewResponse> => {
    const query = new URLSearchParams();
    if (templateId) query.set("templateId", templateId);
    if (reportVersion !== undefined) {
      query.set("reportVersion", String(reportVersion));
    }
    const queryString = query.toString();
    const params = queryString ? `?${queryString}` : "";
    return api.get<DocumentViewResponse>(
      `/cases/${caseId}/document-view${params}`
    );
  },

  fetchInitialPreviewProjection: async (
    caseId: string,
    templateId?: string
  ): Promise<DocumentViewResponse> => {
    const params = templateId
      ? `?${new URLSearchParams({ templateId }).toString()}`
      : "";
    return api.get<DocumentViewResponse>(
      `/cases/${caseId}/sign-off/initial-preview-projection${params}`
    );
  },

  updateClinicalHistory: async (
    caseId: string,
    data: {
      clinicalHistoryNotes?: string;
      indications?: string;
      impressions?: string;
    }
  ): Promise<{
    caseId: string;
    clinicalHistoryNotes: string;
    indications: string;
    impressions: string;
    updatedAt: string;
  }> => {
    return api.put(`/cases/${caseId}/clinical-history`, data);
  },

  savePathologistComment: async (
    caseId: string,
    commentText: string
  ): Promise<{
    id: string;
    caseId: string;
    commentText: string;
    createdById: string;
    updatedAt: string;
  }> => {
    return api.post(`/cases/${caseId}/pathologist-comments`, { commentText });
  },
};
